import * as React from 'react'
import { ReactElement } from 'react'
import BaseCombobox, { BaseComboboxProps } from './BaseCombobox'

type Props = Partial<BaseComboboxProps<AccidentType>>

type AccidentType = {
    key: string
    label: string
    shortLabel?: string
}

const AccidentTypes: AccidentType[] = [
    {
        key: 'MARINE_COLLISION',
        label: 'Aanvaring',
    },
    {
        key: 'AVB', // Assuming AVB is a specific term and does not need translation
        label: 'AVB',
    },
    {
        key: 'WORK_ACCIDENT',
        label: 'Bedrijfsongeval',
    },
    {
        key: 'COLLISION_PEDESTRIAN_CYCLIST',
        label: 'Aanrijding met voetganger/fietser (schuld tegenpartij)',
    },
    {
        key: 'AVP', // Assuming AVP is a specific term and does not need translation
        label: 'AVP',
    },
    {
        key: 'DOG',
        label: 'Hond',
    },
    {
        key: 'OTHER_ANIMALS',
        label: 'Overige met dieren',
    },
    {
        key: 'VIOLENCE_ABUSE',
        label: 'Geweld/mishandeling/misbruik',
    },
    {
        key: 'MEDICAL_ERROR',
        label: 'Medische fout',
    },
    {
        key: 'ARTICLE_185_WVW', // Assuming the translation of 'WVW' remains the same
        label: 'Artikel 185 WVW',
    },
    {
        key: 'DEFECTIVE_STRUCTURE',
        label: 'Gebrekkige opstal',
    },
    {
        key: 'OTHER_CAUSE_DAMAGE',
        label: 'Overige schadeoorzaak',
    },
    {
        key: 'NO_FAULT_THIRD_PARTY_COLLISION',
        label: 'Aanrijding schuldloze derde (passagier)',
    },
    {
        key: 'PRODUCT_LIABILITY',
        label: 'Productaansprakelijkheid',
    },
    {
        key: 'TRAVEL_ORGANIZER',
        label: 'Reisorganisator',
    },
    {
        key: 'SHOCK_DAMAGE',
        label: 'Schockschade',
    },
    {
        key: 'SPORTS_GAME',
        label: 'Sport en Spel',
    },
    {
        key: 'SVI_SVO', // Assuming SVI/SVO is a specific term and does not need translation
        label: 'SVI/SVO',
    },
    {
        key: 'PUBLIC_TRANSPORT',
        label: 'Openbaar vervoer',
    },
    {
        key: 'VEHICLE_COLLISION',
        label: 'Aanrijding met motorvoertuig (schuld tegenpartij)',
    },
    {
        key: 'WAM_OTHER_COLLISION',
        label: 'WAM Aanrijding overig (schuld tegenpartij)',
    },
    {
        key: 'ROAD_MANAGER',
        label: 'Wegbeheerder',
    },
]

export default function AccidentTypeCombobox(props: Props): ReactElement {
    return (
        <BaseCombobox<AccidentType>
            entities={AccidentTypes}
            alphabetical
            getEntityShortLabel={option => option.shortLabel || option.label}
            getEntityLabel={option => option.label}
            getEntityValue={option => option.key}
            multiselect
            {...props}
        />
    )
}
